import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useState } from "react";
import { Button, ButtonVariant, primaryActionLoadingVar, startPrimaryAction, completePrimaryAction } from "@withfriendsco/wf-components";
import { useSaveSubscriptionBenefit } from "../cache/SaveSubscriptionBenefitFunctions";
const SaveSubscriptionBenefit = ({ id, isWelcomeGift, isDriveGift }) => {
    const [saveMessage, setSaveMessage] = useState(null);
    const primaryActionLoading = primaryActionLoadingVar();
    const { wrapped: saveSubscriptionBenefit } = useSaveSubscriptionBenefit(id, isWelcomeGift ? "WelcomeGiftBenefit" : isDriveGift ? "DriveBenefit" : "SubscriptionBenefit");
    const saveBenefit = async () => {
        var _a;
        startPrimaryAction();
        await saveSubscriptionBenefit();
        completePrimaryAction();
        (_a = document.querySelector(`.wf-change-subscription-benefit-${id}`)) === null || _a === void 0 ? void 0 : _a.click();
    };
    return (_jsxs("div", { className: "w-full max-w-lg px-4", children: [_jsx("div", { className: "my-4 border-t-2 border-wfGray-300" }), saveMessage, _jsx(Button, { className: "my-4", variant: ButtonVariant.Salmon, disabled: primaryActionLoading, onClick: saveBenefit, children: "Save Subscription Box" })] }));
};
export default SaveSubscriptionBenefit;
